import clsx from "clsx";
import style from "./floorplanDetails.module.scss";

export default function FloorplanDetailsSkelton() {
  return (
    <div className={style.SkeltonWrapper}>
      <div>
        <h3>Loading Floor Plan Details</h3>
        <div className={clsx(style.SkeltonTitle, style.skeleton)}></div>
        <div className={clsx(style.SkeltonPara, style.skeleton)}></div>
        <div className={clsx(style.SkeltonPara, style.skeleton)}></div>
        <div className={style.SkeltonChips}>
          <ul>
            <li className={style.skeleton}></li>
            <li className={style.skeleton}></li>
            <li className={style.skeleton}></li>
          </ul>
        </div>
      </div>
    </div>
  );
}
